<template>
  <div class="game-management">
    <!-- 顶部操作栏 -->
    <div class="operation-bar">
      <el-row :gutter="20" type="flex" align="middle">
        <el-col :span="4">
          <el-input
            v-model="searchForm.title"
            placeholder="请输入游戏名称"
            clearable
            @clear="handleSearch"
            @keyup.enter.native="handleSearch"
          >
            <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
          </el-input>
        </el-col>
        <el-col :span="4">
          <el-input
            v-model="searchForm.targetId"
            placeholder="请输入魔趣ID"
            clearable
            @clear="handleSearch"
            @keyup.enter.native="handleSearch"
          >
            <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
          </el-input>
        </el-col>
        <el-col :span="3">
          <el-select v-model="searchForm.download_type" placeholder="收费类型" clearable @change="handleSearch">
            <el-option label="收费" value="vip"></el-option>
            <el-option label="免费" value="free"></el-option>
          </el-select>
        </el-col>
        <el-col :span="3">
          <el-select v-model="searchForm.category" placeholder="游戏类型" clearable @change="handleSearch">
            <el-option label="Quest" value="quest"></el-option>
            <el-option label="教程" value="tutorial"></el-option>
            <el-option label="SteamVR" value="steamvr"></el-option>
            <el-option label="其他" value="other"></el-option>
          </el-select>
        </el-col>
        <el-col :span="10" style="text-align: right">
          <el-button-group>
            <el-button type="primary" icon="el-icon-plus" @click="handleAdd">添加游戏</el-button>
            <el-upload
              class="upload-button"
              action=""
              :http-request="handleExcelUpload"
              :show-file-list="false"
              accept=".xlsx,.xls"
            >
              <el-button type="success" icon="el-icon-upload2">一键导入</el-button>
            </el-upload>
            <el-button type="warning" icon="el-icon-refresh" @click="handleSync">同步资源</el-button>
            <el-button type="info" icon="el-icon-download" @click="handleSingleGameCrawl">爬取游戏</el-button>
          </el-button-group>
        </el-col>
      </el-row>
    </div>

    <!-- 游戏列表 -->
    <div class="table-container">
      <el-table :data="gameList" style="width: 100%" v-loading="loading">
        <el-table-column prop="title" label="游戏名称"></el-table-column>
        <el-table-column prop="targetId" label="魔趣ID" width="100"></el-table-column>
        <el-table-column prop="download_type" label="收费类型" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.download_type === 'vip' ? 'danger' : 'success'">
              {{ scope.row.download_type === "vip" ? "收费" : "免费" }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="category" label="游戏类型" width="100">
          <template slot-scope="scope">
            <el-tag :type="getCategoryType(scope.row.category)">
              {{ getCategoryText(scope.row.category) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="game_update_time" label="游戏更新时间" width="180">
          <template slot-scope="scope">
            {{ formatTime(scope.row.game_update_time) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button type="text" class="delete-button" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
        >
        </el-pagination>
      </div>
    </div>

    <!-- 添加/编辑对话框 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="70%"
      :before-close="handleDialogClose"
      class="game-dialog"
    >
      <el-form :model="formData" :rules="rules" ref="gameForm" label-width="100px">
        <el-form-item label="魔趣游戏ID" prop="targetId">
          <el-input v-model="formData.targetId"></el-input>
        </el-form-item>
        <el-form-item label="更新时间" prop="game_update_time">
          <el-input v-model="formData.game_update_time" placeholder="请输入更新时间（格式：YYYY-MM-DD HH:mm:ss）" />
        </el-form-item>
        <el-form-item label="游戏名称" prop="title">
          <el-input v-model="formData.title"></el-input>
        </el-form-item>
        <el-form-item label="游戏主图" prop="cover">
          <div class="cover-input-container">
            <el-input 
              v-model="formData.cover" 
              placeholder="请输入图片地址"
              class="cover-input"
            ></el-input>
            <div class="cover-preview" v-if="formData.cover">
              <img :src="formData.cover" class="preview-image" />
            </div>
          </div>
        </el-form-item>
        <el-form-item label="游戏介绍" prop="content">
          <div class="editor-container">
            <WangEditor v-model="formData.content" :height="300"/>
          </div>
        </el-form-item>
        <el-form-item label="内容图片">
          <div class="content-images-container">
            <div v-for="(image, index) in formData.contentImages" :key="index" class="content-image-item">
              <el-input
                v-model="formData.contentImages[index]"
                placeholder="请输入图片地址"
                class="image-input"
              ></el-input>
              <el-button
                type="text"
                icon="el-icon-delete"
                class="delete-image"
                @click="removeContentImage(index)"
              ></el-button>
            </div>
            <el-button type="text" icon="el-icon-plus" @click="addContentImage">添加图片</el-button>
          </div>
        </el-form-item>
        <el-form-item label="收费类型" prop="download_type">
          <el-radio-group v-model="formData.download_type">
            <el-radio label="vip">收费</el-radio>
            <el-radio label="free">免费</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="游戏类型" prop="category">
          <el-select v-model="formData.category" placeholder="请选择游戏类型">
            <el-option label="Quest" value="quest"></el-option>
            <el-option label="教程" value="tutorial"></el-option>
            <el-option label="SteamVR" value="steamvr"></el-option>
            <el-option label="其他" value="other"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="下载链接">
          <div class="download-links-container">
            <div v-for="(link, index) in formData.download_links" :key="index" class="download-link-item">
              <el-input
                v-model="link.linkUrl"
                placeholder="下载链接"
                class="link-input"
              ></el-input>
              <el-input
                v-model="link.linkName"
                placeholder="平台名称"
                class="platform-input"
              ></el-input>
              <el-button
                type="text"
                icon="el-icon-delete"
                class="delete-link"
                @click="removeLink(index)"
              ></el-button>
            </div>
            <el-button type="text" icon="el-icon-plus" @click="addLink">添加下载链接</el-button>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 同步资源对话框 -->
    <el-dialog
      title="同步资源"
      :visible.sync="syncDialogVisible"
      width="30%"
      class="sync-dialog"
    >
      <el-form :model="syncForm" label-width="100px">
        <el-form-item label="页数">
          <el-input-number v-model="syncForm.totalPages" :min="1" :max="100"></el-input-number>
        </el-form-item>
        <el-form-item label="资源类型">
          <el-select v-model="syncForm.category" placeholder="请选择资源类型">
            <el-option label="Quest" value="quest"></el-option>
            <el-option label="SteamVR" value="steamvr"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="资源路径">
          <el-select v-model="syncForm.path" placeholder="请选择资源路径">
            <el-option label="Oculus" value="oculusquest"></el-option>
            <el-option label="Steam" value="rifts"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="同步时间">
          <el-input-number v-model="syncForm.hour" :min="1" :max="72" placeholder="最近几小时内"></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="syncDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="startSync">开始同步</el-button>
      </div>
    </el-dialog>

        <!-- 爬取单个游戏对话框 -->
        <el-dialog
      title="爬取游戏"
      :visible.sync="crawlDialogVisible"
      width="30%"
      class="crawl-dialog"
    >
      <el-form :model="crawlForm" :rules="crawlRules" ref="crawlForm" label-width="100px">
        <el-form-item label="游戏ID" prop="gameId">
          <el-input v-model="crawlForm.gameId" placeholder="请输入目标网站的游戏ID"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="crawlDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="startSingleGameCrawl">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import WangEditor from "../components/WangEditor";
import { getMqList, addMqGame, updateMqGame, getMqInfoAdmin, deleteMqGame, importMqResource,startMqCrawler,  getSingleGame } from "../api/index";

export default {
  name: "GameManagement",
  components: {
    WangEditor,
  },
  data() {
    return {
      loading: false,
      gameList: [],
      dialogVisible: false,
      syncDialogVisible: false,
      dialogTitle: "",
      searchForm: {
        title: "",
        download_type: "",
        category: "",
        targetId: "",
      },
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      formData: {
        targetId: "",
        game_update_time: "",
        title: "",
        cover: "",
        content: "",
        contentImages: [],
        download_type: "free",
        category: "quest",
        download_links: [],
      },
      syncForm: {
        totalPages: 1,
        category: "quest",
        path: "oculusquest",
        hour: 12
      },
      rules: {
        title: [{ required: true, message: "请输入游戏名称", trigger: "blur" }],
        cover: [{ required: true, message: "请输入游戏主图地址", trigger: "blur" }],
        content: [{ required: true, message: "请输入游戏介绍", trigger: "blur" }],
        download_type: [{ required: true, message: "请选择收费类型", trigger: "change" }],
        category: [{ required: true, message: "请选择游戏类型", trigger: "change" }],
      },
      crawlDialogVisible: false,
      crawlForm: {
        gameId: ""
      },
      crawlRules: {
        gameId: [
          { required: true, message: "请输入游戏ID", trigger: "blur" },
          { pattern: /^\d+$/, message: "游戏ID必须为数字", trigger: "blur" }
        ]
      }
    };
  },
  created() {
    this.fetchGameList();
  },
  methods: {
    // 获取游戏列表
    async fetchGameList() {
      try {
        this.loading = true;
        const params = {
          page: this.pagination.currentPage,
          pageSize: this.pagination.pageSize,
          ...this.searchForm,
        };
        const res = await getMqList(params);
        this.gameList = res.data.data;
        this.pagination.total = res.data.pagination.total;
      } catch (error) {
        console.error(error);
        this.$message.error("获取游戏列表失败");
      } finally {
        this.loading = false;
      }
    },

    // 搜索
    handleSearch() {
      this.pagination.currentPage = 1;
      this.fetchGameList();
    },

    // 添加游戏
    handleAdd() {
      this.dialogTitle = "添加游戏";
      this.formData = {
        title: "",
        cover: "",
        content: "",
        contentImages: [],
        download_type: "free",
        category: "quest",
        download_links: [],
      };
      this.dialogVisible = true;
    },

    // 编辑游戏
    async handleEdit(row) {
      try {
        const res = await getMqInfoAdmin(row.id);
        this.formData = res.data;
        this.dialogTitle = "编辑游戏";
        this.dialogVisible = true;
      } catch (error) {
        console.error(error);
        this.$message.error("获取游戏详情失败");
      }
    },

    // 删除游戏
    handleDelete(row) {
      this.$confirm("确认删除该游戏？", "提示", {
        type: "warning",
      })
        .then(async () => {
          try {
            await deleteMqGame(row.id);
            this.$message.success("删除成功");
            this.fetchGameList();
          } catch (error) {
            console.error(error);
            this.$message.error("删除失败");
          }
        })
        .catch(() => {});
    },

    // 提交表单
    handleSubmit() {
      this.$refs.gameForm.validate(async (valid) => {
        if (valid) {
          try {
            if (this.formData.id) {
              await updateMqGame(this.formData);
              this.$message.success("更新成功");
            } else {
              await addMqGame(this.formData);
              this.$message.success("添加成功");
            }
            this.dialogVisible = false;
            this.fetchGameList();
          } catch (error) {
            console.error(error);
            this.$message.error("操作失败");
          }
        }
      });
    },

    // 处理Excel导入
    async handleExcelUpload(params) {
      try {
        const formData = new FormData();
        formData.append("file", params.file);
        await importMqResource(formData);
        this.$message.success("导入成功");
        this.fetchGameList();
      } catch (error) {
        console.error(error);
        this.$message.error("导入失败");
      }
    },

    // 同步资源
    handleSync() {
      this.syncDialogVisible = true;
    },

    // 开始同步
    async startSync() {
      try {
        await startMqCrawler(this.syncForm)
        // await this.$http.get("/resource/startMqCrawler", {
        //   params: this.syncForm
        // });
        this.$message.success("同步任务已启动");
        this.syncDialogVisible = false;
      } catch (error) {
        console.error(error);
        this.$message.error("同步任务启动失败");
      }
    },

    // 添加内容图片
    addContentImage() {
      this.formData.contentImages.push("");
    },

    // 删除内容图片
    removeContentImage(index) {
      this.formData.contentImages.splice(index, 1);
    },

    // 添加下载链接
    addLink() {
      this.formData.download_links.push({
        linkUrl: "",
        linkName: "",
      });
    },

    // 删除下载链接
    removeLink(index) {
      this.formData.download_links.splice(index, 1);
    },

    // 分页大小改变
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.fetchGameList();
    },

    // 当前页改变
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.fetchGameList();
    },

    // 对话框关闭前
    handleDialogClose(done) {
      this.$refs.gameForm.resetFields();
      done();
    },

    // 获取类型标签样式
    getCategoryType(category) {
      const typeMap = {
        quest: "primary",
        tutorial: "success",
        steamvr: "warning",
        other: "info",
      };
      return typeMap[category] || "info";
    },

    // 获取类型文本
    getCategoryText(category) {
      const textMap = {
        quest: "Quest",
        tutorial: "教程",
        steamvr: "SteamVR",
        other: "其他",
      };
      return textMap[category] || "其他";
    },

    // 格式化时间
    formatTime(time) {
      if (!time) return '-';
      const date = new Date(time);
      return date.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      });
    },

        // 打开爬取单个游戏对话框
    handleSingleGameCrawl() {
      this.crawlForm = {
        gameId: ""
      };
      this.crawlDialogVisible = true;
    },

    // 开始爬取单个游戏
    startSingleGameCrawl() {
      this.$refs.crawlForm.validate(async (valid) => {
        if (valid) {
          try {
            await getSingleGame(this.crawlForm.gameId);
            // this.$message.success("游戏爬取成功");
            this.crawlDialogVisible = false;
            this.fetchGameList();
          } catch (error) {
            console.error(error);
            // this.$message.error("游戏爬取失败");
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.game-management {
  padding: 20px;

  .operation-bar {
    background-color: #fff;
    padding: 16px;
    margin-bottom: 16px;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

    .el-select {
      width: 100%;
    }

    .upload-button {
      display: inline-block;
    }

    .el-button-group {
      .el-button {
        margin: 0;
      }
    }
  }

  .table-container {
    background-color: #fff;
    padding: 16px;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

    .delete-button {
      color: #f56c6c;
    }
  }

  .pagination-container {
    margin-top: 20px;
    text-align: right;
  }

  .game-dialog {
    .cover-input-container {
      display: flex;
      gap: 16px;
      align-items: flex-start;

      .cover-input {
        flex: 1;
      }

      .cover-preview {
        width: 120px;
        height: 120px;
        border: 1px solid #dcdfe6;
        border-radius: 4px;
        overflow: hidden;

        .preview-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }

    .editor-container {
      border: 1px solid #dcdfe6;
      border-radius: 4px;
    }

    .content-images-container,
    .download-links-container {
      .content-image-item,
      .download-link-item {
        display: flex;
        gap: 8px;
        margin-bottom: 8px;
        align-items: center;

        .image-input,
        .link-input {
          flex: 1;
        }

        .platform-input {
          width: 120px;
        }

        .delete-image,
        .delete-link {
          color: #f56c6c;
          padding: 0;
        }
      }
    }
  }

  .sync-dialog {
    .el-select,
    .el-input-number {
      width: 100%;
    }
  }
}
</style>